import { createBrowserRouter, Navigate } from 'react-router-dom';
import Layout from './index';
import ClientListPage from './ClientListPage';
import DeviceDetailPage from './DeviceDetailPage';
import ExecutiveSummaryPage from './ExecutiveSummaryPage';
import AlertHistoryPage from './AlertHistoryPage';
import SettingsPage from './SettingsPage';

/**
 * Application router using React Router v7 library/SPA mode.
 * createBrowserRouter is preferred for full SPA navigation.
 *
 * Routes:
 * - / → redirects to /clients
 * - /clients → ClientListPage (full implementation — Plan 03)
 * - /clients/:id/devices → DeviceDetailPage (full implementation — Plan 03)
 * - /dashboard → ExecutiveSummaryPage (full implementation — Plan 04)
 */
const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Navigate to="/clients" replace />,
      },
      {
        path: '/clients',
        element: <ClientListPage />,
      },
      {
        path: '/clients/:id/devices',
        element: <DeviceDetailPage />,
      },
      {
        path: '/dashboard',
        element: <ExecutiveSummaryPage />,
      },
      {
        path: '/alerts',
        element: <AlertHistoryPage />,
      },
      {
        path: '/settings',
        element: <SettingsPage />,
      },
    ],
  },
]);

export default router;
